var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "container-fluid" },
    [
      _c("BarreFiltres", {
        attrs: { filtres: _vm.filtres },
        on: {
          "appliquer-filtre": function($event) {
            return _vm.appliquerFiltre($event)
          }
        }
      }),
      _vm._m(0)
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "flex-center-center" }, [
      _c(
        "div",
        { staticClass: "card col-12 col-xl-10 col-xxl-8 height-responsive" },
        [
          _c("div", { staticClass: "card-header" }, [
            _vm._v(" Commandes - Documentation ")
          ]),
          _c(
            "div",
            {
              staticClass:
                "card-container height-responsive-body height-responsive-1b"
            },
            [
              _c("div", { staticClass: "card-body" }, [
                _c("section", { attrs: { id: "sectionCommandes" } }, [
                  _c("p", [
                    _vm._v(
                      "Sur cette page, vous avez la possibilité d'accéder à la liste de vos commandes"
                    )
                  ]),
                  _c("p", [
                    _vm._v(
                      'Vous avez la possibilité de créer une nouvelle commande en cliquant sur "Créer une nouvelle commande". '
                    )
                  ]),
                  _c("div", { staticClass: "container mb-3" }, [
                    _c("img", {
                      staticClass: "border-black border-rounded w-100",
                      attrs: {
                        src: require("../../assets/images/documentation/commandes/suivi/creerCommande.png"),
                        alt: "Image création commande"
                      }
                    })
                  ]),
                  _c("p", [
                    _vm._v(
                      "Après l'ouverture de la fenêtre, vous pourrez nommer votre commande et spécifier la période désirée. Ensuite, deux options s'offrent à vous :"
                    )
                  ]),
                  _c("ul", { staticClass: "puces" }, [
                    _c("li", [
                      _vm._v("Vous avez la possibilité d'entrer des"),
                      _c(
                        "a",
                        { attrs: { href: "#sectionCommandesManuelle" } },
                        [_vm._v(" commandes vierges.")]
                      )
                    ]),
                    _c("li", [
                      _vm._v("Vous pouvez également utiliser des"),
                      _c(
                        "a",
                        { attrs: { href: "#sectionCommandesPrecalculees" } },
                        [_vm._v(" commandes précalculées ")]
                      ),
                      _vm._v("à partir des menus")
                    ])
                  ])
                ])
              ]),
              _c("section", { attrs: { id: "sectionCommandesManuelle" } }, [
                _c("div", { staticClass: "header header-tertiary" }, [
                  _vm._v("Commande vierge")
                ]),
                _c("div", { staticClass: "card-body" }, [
                  _c("div", { staticClass: "container mb-3" }, [
                    _c("img", {
                      staticClass: "border-black border-rounded w-100",
                      attrs: {
                        src: require("../../assets/images/documentation/commandes/suivi/commandeManuelSuivi.png"),
                        alt: "Image commandes Manuel"
                      }
                    })
                  ]),
                  _c("p", [
                    _c("span", { staticClass: "bold600" }, [
                      _vm._v("Section 1")
                    ]),
                    _vm._v(
                      ": dans la barre du haut, de gauche à droite, vous trouverez les éléments suivants :"
                    )
                  ]),
                  _c("div", { staticClass: "container mb-3" }, [
                    _c("img", {
                      staticClass: "border-black border-rounded w-100",
                      attrs: {
                        src: require("../../assets/images/documentation/commandes/suivi/commandeSection1.png"),
                        alt: "Image commandes section 1"
                      }
                    })
                  ]),
                  _c("ul", { staticClass: "puces" }, [
                    _c("li", [
                      _vm._v("Choisir produit : Pour accéder à la "),
                      _c("a", { attrs: { href: "#sectionMercuriale" } }, [
                        _vm._v("Mercuriale.")
                      ])
                    ]),
                    _c("li", [
                      _vm._v(
                        "Optimiser prix: Permet de trouver le prix le plus intérressant sur toutes les lignes de la commande."
                      )
                    ]),
                    _c("li", [
                      _vm._v(
                        "Optimiser fournisseurs: Permet de regrouper la commande sur le moins de fournisseurs possible."
                      )
                    ]),
                    _c("li", [
                      _vm._v(
                        "Choisir fournisseur: Permet de basculer le plus de produit possible sur un fournisseur selectionné."
                      )
                    ]),
                    _c("li", [
                      _vm._v(
                        "Exporter: Permet de récupérer de manière brute les lignes de commandes au format Excel."
                      )
                    ]),
                    _c("li", [
                      _vm._v("Bon de commande: Permet de "),
                      _c("a", { attrs: { href: "#sectionPasserCommande" } }, [
                        _vm._v("passer votre commande")
                      ]),
                      _vm._v(
                        " par fournisseur ou d'envoyer votre commande à tous les fournisseurs en une seule action "
                      )
                    ]),
                    _c("li", [
                      _c("button", { staticClass: "btn btn-primary btn-sm" }, [
                        _c("i", { staticClass: "fas fa-caret-up" })
                      ]),
                      _vm._v(" "),
                      _c("button", { staticClass: "btn btn-primary btn-sm" }, [
                        _c("i", { staticClass: "fas fa-caret-down" })
                      ]),
                      _vm._v(
                        " Permet de trier les lignes de la commande, remonte ou descends la ligne dans la liste. Ce tri est maintenu à l'enregistrement de la commande"
                      )
                    ]),
                    _c("li", [
                      _vm._v("Retour: Vous ramène à la liste de vos commandes.")
                    ]),
                    _c("li", [
                      _vm._v("Annuler: Annule vos dernières modifications")
                    ]),
                    _c("li", [_vm._v("Enregistrer: Enregistre votre commande")])
                  ]),
                  _c("p", [
                    _c("span", { staticClass: "bold600" }, [
                      _vm._v("Section 2")
                    ]),
                    _vm._v(": Ligne produits de votre commande")
                  ]),
                  _c("div", { staticClass: "container" }, [
                    _c(
                      "table",
                      { staticClass: "table table-bordered text-center" },
                      [
                        _c("thead", { staticClass: "table-header" }, [
                          _c("th", [_vm._v("Légende")]),
                          _c("th", { staticClass: "aligner-gauche" }, [
                            _vm._v("Signification")
                          ])
                        ]),
                        _c("tbody", [
                          _c("tr", [
                            _c("td", [
                              _c(
                                "span",
                                { staticClass: "table ligne-modifiee" },
                                [_vm._v("Police en gras et italique")]
                              )
                            ]),
                            _c("td", { staticClass: "aligner-gauche" }, [
                              _vm._v("Produit modifié.")
                            ])
                          ]),
                          _c("tr", [
                            _c("td", [
                              _c(
                                "span",
                                { staticClass: "table ligne-desactivee" },
                                [_vm._v("Police en gris et italique")]
                              )
                            ]),
                            _c("td", { staticClass: "aligner-gauche" }, [
                              _vm._v(
                                "La commande de ce produit a été réalisée."
                              )
                            ])
                          ]),
                          _c("tr", [
                            _c("td", { staticClass: "warning" }, [
                              _c("em", [
                                _c("i", {
                                  staticClass:
                                    "fas fa-exclamation-triangle ligne-modifiee"
                                }),
                                _vm._v(" Produit sans ingrédient")
                              ])
                            ]),
                            _c("td", { staticClass: "aligner-gauche" }, [
                              _vm._v(
                                "Indique qu'un produit hors marché n'est rattaché à aucun ingrédient. Il faut associer un ingrédient au produit à partir de la page \"Produits hors marché\" afin de profiter des comparaisons de prix lors des substitutions de fournisseurs et de la sélection automatique dans les commandes depuis les recettes."
                              )
                            ])
                          ]),
                          _c("tr", [
                            _c("td", { staticClass: "bg-error" }, [
                              _vm._v("Ingrédient indisponible avec fond rouge")
                            ]),
                            _c("td", { staticClass: "aligner-gauche" }, [
                              _vm._v("Indique qu'un produit est indisponible.")
                            ])
                          ]),
                          _c("tr", [
                            _c("td", { staticClass: "bg-error" }, [
                              _vm._v("Case fournisseur en rouge")
                            ]),
                            _c("td", { staticClass: "aligner-gauche" }, [
                              _vm._v(
                                "Signifie qu'un produit a été sélectionné par la désignation, mais aucune référence fournisseur n'a été choisie."
                              )
                            ])
                          ]),
                          _c("tr", [
                            _c("td", { staticClass: "bg-warning" }, [
                              _vm._v("Case Qté. PCB en jaune")
                            ]),
                            _c("td", { staticClass: "aligner-gauche" }, [
                              _vm._v(
                                "Signifie que la quantité demandée et diffrente de la quantité PCB "
                              )
                            ])
                          ]),
                          _c("tr", [
                            _c("td", [
                              _c(
                                "button",
                                {
                                  staticClass: "btn btn-primary",
                                  attrs: { type: "button" }
                                },
                                [
                                  _c("i", {
                                    staticClass: "fas fa-exchange-alt"
                                  })
                                ]
                              )
                            ]),
                            _c("td", { staticClass: "aligner-gauche" }, [
                              _c(
                                "a",
                                { attrs: { href: "#sectionSubstitution" } },
                                [_vm._v("Substitution de produit.")]
                              ),
                              _vm._v(
                                " Permet également d'accéder aux fiches techniques et d'ajouter des favoris. Cliquer sur le point vert en bout de ligne, pour changer de produit."
                              )
                            ])
                          ]),
                          _c("tr", [
                            _c("td", [
                              _c(
                                "button",
                                {
                                  staticClass: "btn btn-danger",
                                  attrs: { type: "button" }
                                },
                                [_c("i", { staticClass: "fas fa-trash" })]
                              )
                            ]),
                            _c("td", { staticClass: "aligner-gauche" }, [
                              _vm._v("Suppression du produit.")
                            ])
                          ])
                        ])
                      ]
                    ),
                    _c("div", { staticClass: "container mb-3" }, [
                      _c("img", {
                        staticClass: "border-black border-rounded w-100",
                        attrs: {
                          src: require("../../assets/images/documentation/commandes/suivi/commandeSection2.png"),
                          alt: "Image commandes Manuel"
                        }
                      })
                    ]),
                    _c("p", [
                      _vm._v(
                        "Dans cette section, vous retrouvez plusieurs colonnes : "
                      )
                    ]),
                    _c("ul", { staticClass: "puces" }, [
                      _c("li", [_vm._v("Fam: La famille du produit")]),
                      _c("li", [
                        _vm._v(
                          "Désignation: Description du produit selectionné"
                        )
                      ]),
                      _c("li", [
                        _vm._v(
                          "Fournisseurs: Liste des différents fournisseurs"
                        )
                      ]),
                      _c("li", [_vm._v("Réf.: Référence des produits")]),
                      _c("li", [_vm._v("Marque: Marque des produits")]),
                      _c("li", [
                        _vm._v(
                          "Qté. stock: La quantité du produit déja présent dans votre stock"
                        )
                      ]),
                      _c("li", [
                        _vm._v(
                          "Qté. demandée: La quantité que vous avez selectionnée"
                        )
                      ]),
                      _c("li", [
                        _vm._v(
                          "Qté. PCB (PCB): La quantité qui va être commandée."
                        )
                      ]),
                      _c("li", [_vm._v("PU HT: Prix Unitaire Hors Taxe")]),
                      _c("li", [
                        _vm._v("Total HT: Total du PU HT x Qté. PCB (PCB)")
                      ])
                    ]),
                    _c("div", { staticClass: "h6 important" }, [
                      _c("h6", [_vm._v("ASTUCE")]),
                      _c("p", [
                        _vm._v(
                          "Chaque colonne est triable. Pour trier une colonne, cliquez simplement sur son en-tête."
                        )
                      ]),
                      _c("p", [
                        _vm._v(
                          'Exemple : si vous cliquez sur "Désignation", tous les produits seront classés par ordre alphabétique.'
                        )
                      ])
                    ])
                  ]),
                  _c("p", [
                    _c("span", { staticClass: "bold600" }, [
                      _vm._v("Section 3")
                    ]),
                    _vm._v(": Details fournisseurs")
                  ]),
                  _c("div", { staticClass: "container mb-3" }, [
                    _c("img", {
                      staticClass: "border-black border-rounded w-100",
                      attrs: {
                        src: require("../../assets/images/documentation/commandes/suivi/commandeSection3.png"),
                        alt: "Image commandes Manuel"
                      }
                    })
                  ]),
                  _c("p", [
                    _vm._v(
                      "Cette section est équipée d'un filtre qui facilite le tri des produits par fournisseur. Une fois le filtre activé, il vous suffit de choisir un fournisseur dans la liste pour afficher les produits correspondants."
                    )
                  ]),
                  _c("ul", { staticClass: "puces" }, [
                    _c("li", [
                      _vm._v(
                        "Fournisseur : Indique les fournisseurs que vous avez sélectionnés pour votre commande."
                      )
                    ]),
                    _c("li", [
                      _vm._v(
                        "Lignes: Correspond à la quantité de produits commandés par fournisseur."
                      )
                    ]),
                    _c("li", [
                      _vm._v(
                        "Bon de commande: Le numéro du bon de commande est généré automatiquement. Si vous souhaitez le modifier, vous pouvez le faire en cliquant dessus."
                      )
                    ]),
                    _c("li", [
                      _vm._v(
                        "Livraison: Si le champ est laissé vide, la commande ne peut pas être effectuée. En cliquant dessus, un calendrier s'ouvre (voir l'image ci-dessous), les jours marqués en vert sont ceux préalablement paramétrés dans le menu fournisseurs. Par défaut, la date sélectionnée sera la plus proche de la création de la recette."
                      )
                    ]),
                    _c("li", [
                      _vm._v(
                        "Franco: Si le montant de franco n'est pas atteint, il sera affiché avec un "
                      ),
                      _c(
                        "span",
                        { staticClass: "bg-warning p-1 border-rounded" },
                        [_vm._v(" fond jaune")]
                      )
                    ]),
                    _c("li", [
                      _vm._v(
                        "Total HT: indique le montant total de la commande par fournisseur"
                      )
                    ])
                  ]),
                  _c("p", [_vm._v("Livraison:")]),
                  _c("div", { staticClass: "flex-center-center mb-3" }, [
                    _c("div", { staticClass: "col-6" }, [
                      _c("img", {
                        staticClass: "border-black border-rounded w-100",
                        attrs: {
                          src: require("../../assets/images/documentation/commandes/suivi/commandeLivraison.png"),
                          alt: "Image livraison"
                        }
                      })
                    ])
                  ]),
                  _c("div", { staticClass: "container" }, [
                    _c(
                      "table",
                      { staticClass: "table table-bordered text-center" },
                      [
                        _c("thead", { staticClass: "table-header" }, [
                          _c("th", [_vm._v("Légende")]),
                          _c("th", { staticClass: "aligner-gauche" }, [
                            _vm._v("Signification")
                          ])
                        ]),
                        _c("tbody", [
                          _c("tr", [
                            _c("td", [
                              _c(
                                "button",
                                {
                                  staticClass: "btn btn-primary",
                                  attrs: { type: "button" }
                                },
                                [_c("i", { staticClass: "fas fa-envelope" })]
                              )
                            ]),
                            _c("td", { staticClass: "aligner-gauche" }, [
                              _vm._v("Envoyer le bon de commande par mail.")
                            ])
                          ]),
                          _c("tr", [
                            _c("td", [
                              _c(
                                "button",
                                {
                                  staticClass: "btn btn-primary",
                                  attrs: { type: "button" }
                                },
                                [_c("i", { staticClass: "fas fa-phone" })]
                              )
                            ]),
                            _c("td", { staticClass: "aligner-gauche" }, [
                              _vm._v(
                                "Cette fonctionnalité est à utiliser lorsque vous avez passé votre commande par téléphone ou que vous avez envoyé le bon de commande manuellement."
                              )
                            ])
                          ]),
                          _c("tr", [
                            _c("td", [
                              _c(
                                "button",
                                {
                                  staticClass: "btn btn-primary",
                                  attrs: { type: "button" }
                                },
                                [
                                  _c("i", {
                                    staticClass: "fas fa-dolly-flatbed"
                                  })
                                ]
                              )
                            ]),
                            _c("td", { staticClass: "aligner-gauche" }, [
                              _vm._v(
                                "Cette fonctionnalité est à utiliser lors de la"
                              ),
                              _c(
                                "a",
                                { attrs: { href: "#sectionReception" } },
                                [_vm._v(" réception de votre commande")]
                              ),
                              _vm._v(".")
                            ])
                          ])
                        ])
                      ]
                    )
                  ])
                ])
              ]),
              _c("section", { attrs: { id: "sectionSubstitution" } }, [
                _c("div", { staticClass: "header header-tertiary" }, [
                  _vm._v("Substitution de produit")
                ]),
                _c("div", { staticClass: "card-body" }, [
                  _c("p", [
                    _vm._v(
                      "Après voir cliqué sur le bouton de substitution de produit "
                    ),
                    _c(
                      "button",
                      {
                        staticClass: "btn btn-primary btn-sm",
                        attrs: {
                          title: "Substitution de produit",
                          type: "button"
                        }
                      },
                      [_c("i", { staticClass: "fas fa-exchange-alt" })]
                    ),
                    _vm._v(", cela vous ouvre la fenêtre ci-dessous.")
                  ]),
                  _c("p", [
                    _vm._v(
                      "Sur celle-ci, vous trouverez des produits similaires. Vous pouvez consulter la fiche technique de chaque produit en utilisant : "
                    ),
                    _c(
                      "button",
                      {
                        staticClass: "btn btn btn-primary btn-secondary btn-sm",
                        attrs: { title: "Fiche technique", type: "button" }
                      },
                      [_c("i", { staticClass: "fas fa-book-open" })]
                    )
                  ]),
                  _c("p", [
                    _vm._v("Vous avez la posibilité d'utiliser l'étoile "),
                    _c("i", { staticClass: "fa-star far" }),
                    _vm._v(" pour ajouter un produit dans vos favoris.")
                  ]),
                  _c("p", [
                    _vm._v(
                      "Pour confirmer la substitution d'un produit, il vous suffit de cliquer la ligne de votre choix puis de valider avec le bouton "
                    ),
                    _c(
                      "button",
                      {
                        staticClass: "btn btn-primary btn-sm",
                        attrs: { type: "button" }
                      },
                      [_vm._v("Choisir")]
                    ),
                    _vm._v(".")
                  ]),
                  _c("p", [
                    _vm._v(
                      "L'article qui est présent dans votre commande est surligné en gris clair."
                    )
                  ]),
                  _c("div", { staticClass: "container mb-3" }, [
                    _c("img", {
                      staticClass: "border-black border-rounded w-100",
                      attrs: {
                        src: require("../../assets/images/documentation/commandes/suivi/commandeSubstitution.png"),
                        alt: "Image substitution de produit"
                      }
                    })
                  ])
                ])
              ]),
              _c("section", { attrs: { id: "sectionCommandesPrecalculees" } }, [
                _c("div", { staticClass: "header header-tertiary" }, [
                  _vm._v("Commande précalculées")
                ]),
                _c("div", { staticClass: "card-body" }, [
                  _c("div", { staticClass: "container mb-3" }, [
                    _c("img", {
                      staticClass: "border-black border-rounded w-100",
                      attrs: {
                        src: require("../../assets/images/documentation/commandes/suivi/commandesSuivi.png"),
                        alt: "Image commandes Suivi"
                      }
                    })
                  ]),
                  _c("p", [
                    _c("span", { staticClass: "bold600" }, [
                      _vm._v("Dans la section numéro 1,")
                    ]),
                    _vm._v(
                      " vous trouverez l'ensemble des produits, et c'est à ce niveau que vous pouvez modifier un produit ou le supprimer."
                    )
                  ]),
                  _c("p", [
                    _c("span", { staticClass: "bold600" }, [
                      _vm._v("Dans la section numéro 2,")
                    ]),
                    _vm._v(
                      " si vous sélectionnez un produit dans l'encadré numéro 1, vous obtiendrez des informations sur les recettes qui utilisent ce produit, y compris la quantité et la date prévue d'utilisation."
                    )
                  ]),
                  _c("p", [
                    _c("span", { staticClass: "bold600" }, [
                      _vm._v("Dans la section numéro 3,")
                    ]),
                    _vm._v(
                      ' vous trouverez la liste des fournisseurs sélectionnés pour cette commande. En cliquant sur la date de livraison, vous pouvez choisir une nouvelle date. Par défaut, la date choisie est la plus proche de la réalisation de la recette. Vous pouvez visualiser les produits par fournisseur en utilisant le filtre "Filtrer selon le fournisseur sélectionné".'
                    )
                  ])
                ])
              ]),
              _c("section", { attrs: { id: "sectionMercuriale" } }, [
                _c("div", { staticClass: "header header-tertiary" }, [
                  _vm._v("Mercuriale")
                ]),
                _c("div", { staticClass: "card-body" }, [
                  _c("p", [
                    _vm._v(
                      "La page mercuriale vous permet de retrouver tous les produits négociés par notre service achats."
                    )
                  ]),
                  _c("p", [
                    _c("span", { staticClass: "bold600" }, [
                      _vm._v("Section 1")
                    ]),
                    _vm._v(
                      ": dans la barre du haut, de gauche à droite, vous trouverez les éléments suivants :"
                    )
                  ]),
                  _c("ul", { staticClass: "puces" }, [
                    _c("li", [_vm._v("Recherche toutes familles")]),
                    _c("li", [_vm._v("Les différentes familles.")]),
                    _c("li", [
                      _vm._v("Les produits de la mercuriale ou "),
                      _c("a", { attrs: { href: "#sectionProduitsHM" } }, [
                        _vm._v("les produits hors marché.")
                      ])
                    ]),
                    _c("li", [
                      _vm._v(
                        "Une barre de recherche qui s'effectue dans la famille sélectionnée. Vous avez la possibilité de naviguer entre les différentes familles tout en maintenant votre recherche."
                      )
                    ]),
                    _c("li", [
                      _c("a", { attrs: { href: "#sectionFavoris" } }, [
                        _vm._v("Favoris")
                      ])
                    ])
                  ]),
                  _c("div", { staticClass: "container mb-3" }, [
                    _c("img", {
                      staticClass: "border-black border-rounded w-100",
                      attrs: {
                        src: require("../../assets/images/documentation/commandes/mercuriale/mercuriale.png"),
                        alt: "Image Mercuriale"
                      }
                    })
                  ]),
                  _c("p", [
                    _c("span", { staticClass: "bold600" }, [
                      _vm._v("Section 2")
                    ]),
                    _vm._v(
                      ": une fois votre recherche effectuée, plusieurs colonnes apparaissent :"
                    )
                  ]),
                  _c("ul", { staticClass: "puces" }, [
                    _c("li", [
                      _vm._v(
                        "New indique qu'il s'agit d'un nouveau produit dans la mercuriale."
                      )
                    ]),
                    _c("li", [
                      _vm._v(
                        "Designation liste les différents résultats suite à votre recherche."
                      )
                    ]),
                    _c("li", [_vm._v("UC représente l'Unité de Cotation")]),
                    _c("li", [
                      _vm._v(
                        "Vous trouverez ensuite les tarifs pour les différents fournisseurs ainsi que les références."
                      )
                    ])
                  ]),
                  _c("p", [
                    _c("span", { staticClass: "bold600" }, [
                      _vm._v(" Section 3")
                    ]),
                    _vm._v(
                      ": en cliquant sur la référence d'un produit, vous pouvez obtenir plus d'informations à son sujet."
                    )
                  ]),
                  _c("div", { staticClass: "container" }, [
                    _c("div", { staticClass: "flex-center-center mb-3" }, [
                      _c("div", { staticClass: "col-4" }, [
                        _c("img", {
                          staticClass: "border-black border-rounded w-100",
                          attrs: {
                            src: require("../../assets/images/documentation/commandes/mercuriale/mercurialeSection3.png"),
                            alt: "Image mercuriale section 3"
                          }
                        })
                      ])
                    ]),
                    _c(
                      "table",
                      { staticClass: "table table-bordered text-center" },
                      [
                        _c("thead", { staticClass: "table-header" }, [
                          _c("tr", [
                            _c("th", [_vm._v("Bouton")]),
                            _c("th", { staticClass: "aligner-gauche" }, [
                              _vm._v("Signification")
                            ])
                          ])
                        ]),
                        _c("tbody", [
                          _c("tr", [
                            _c("td", [
                              _c(
                                "button",
                                {
                                  staticClass:
                                    "btn btn btn-primary btn-secondary",
                                  attrs: {
                                    title: "Fiche technique",
                                    type: "button"
                                  }
                                },
                                [_c("i", { staticClass: "fas fa-book-open" })]
                              )
                            ]),
                            _c("td", { staticClass: "aligner-gauche" }, [
                              _vm._v("Permet d'accéder à la fiche technique.")
                            ])
                          ]),
                          _c("tr", [
                            _c("td", [
                              _c("i", {
                                staticClass: "fas fa-star text-warning"
                              })
                            ]),
                            _c("td", { staticClass: "aligner-gauche" }, [
                              _vm._v("Produit en favoris.")
                            ])
                          ]),
                          _c("tr", [
                            _c("td", { staticClass: "text-warning" }, [
                              _vm._v("Vendu par")
                            ]),
                            _c("td", { staticClass: "aligner-gauche" }, [
                              _vm._v(
                                " Signifie que la quantité demandée et différente de la quantité PCB."
                              )
                            ])
                          ])
                        ])
                      ]
                    ),
                    _c("p", [
                      _vm._v(
                        "Exemple: Pour ma recette, j'ai besoin de 13 Kg de couscous. Cependant, le PCB (par combien) du fournisseur est de 5 Kg. Votre commande sera effectuée avec le PCB du fournisseur, soit 15Kg."
                      )
                    ])
                  ]),
                  _c("p", [
                    _c("span", { staticClass: "bold600" }, [
                      _vm._v("Section 4")
                    ]),
                    _vm._v(
                      ': affiche la liste des produits qui seront ajoutés à votre commande une fois que vous aurez appuyé sur le bouton "Ajouter les lignes".'
                    )
                  ]),
                  _c("div", { staticClass: "h6 important" }, [
                    _c("p", [
                      _vm._v(
                        "Pour retirer un produit de la liste d'ajout, vous disposez de deux options : "
                      )
                    ]),
                    _c("ul", { staticClass: "puces" }, [
                      _c("li", [
                        _vm._v(
                          "Soit en indiquant une quantité de 0, ce qui le maintiendra dans la liste tout en le barrant. Lorsque vous enregistrez votre commande, la ligne correspondante sera supprimée."
                        )
                      ]),
                      _c("li", [
                        _vm._v(
                          "Soit en désélectionnant la ligne. Pour cela, positionnez-vous sur le produit dans la liste, section 4 et cliquez sur la référence en bleu, section 2."
                        )
                      ])
                    ])
                  ])
                ])
              ]),
              _c("section", { attrs: { id: "sectionFavoris" } }, [
                _c("div", { staticClass: "header header-tertiary" }, [
                  _vm._v("Favoris")
                ]),
                _c("div", { staticClass: "card-body" }, [
                  _c("div", { staticClass: "container mb-3" }, [
                    _c("img", {
                      staticClass: "border-black border-rounded w-100",
                      attrs: {
                        src: require("../../assets/images/documentation/commandes/suivi/favorisMercuriale.png"),
                        alt: "Image bon de commande"
                      }
                    })
                  ]),
                  _c("p", [
                    _vm._v(
                      "Vous avez la possibilité de mettre en favoris l'ensemble de la ligne avec toutes ses références ou de sélectionner une référence spécifique à marquer comme favori. Dans l'exemple ci-dessus, l'icône \"Favoris\" est cochée pour le Steak Végétal Soja Nature IQF 100g, ce qui signifie que toutes les références de cette ligne sont en favoris. Lorsque vous créez vos recettes, la référence la mieux placée sera mise en avant."
                    )
                  ]),
                  _c("p", [
                    _vm._v(
                      "Cependant, dans l'exemple où seule la référence 245234 est marquée comme favori, lors de la création de vos recettes, seule cette référence sera mise en avant, sans comparaison de prix avec d'autres références."
                    )
                  ]),
                  _c("p", [
                    _vm._v(
                      'Vous pouvez retrouver, par famille, tous vos favoris en cochant la case en haut à droite "Favoris"'
                    )
                  ]),
                  _c("p", [
                    _vm._v(
                      "Les favoris sont enregistrés pour votre établissement. Tous les utilisateurs qui se connecterons sur votre établissemet verront les mêmes favoris."
                    )
                  ]),
                  _c("p", [
                    _vm._v(
                      "Si vous gérez plusieurs établissements, vous avez la possibilité de dupliquer les favoris d'un établissement à un autre en cliquant sur le bouton "
                    ),
                    _c(
                      "button",
                      {
                        staticClass: "btn btn-primary btn-sm",
                        attrs: { type: "button" }
                      },
                      [_vm._v("Dupliquer les favoris")]
                    )
                  ])
                ])
              ]),
              _c("section", { attrs: { id: "sectionPasserCommande" } }, [
                _c("div", { staticClass: "header header-tertiary" }, [
                  _vm._v("Passer une commande")
                ]),
                _c("div", { staticClass: "card-body" }, [
                  _c("p", [
                    _vm._v(
                      "Une fois que vous avez finalisé votre choix de produits, vous pouvez passer commande auprès des fournisseurs de deux manières :"
                    )
                  ]),
                  _c("ul", { staticClass: "puces" }, [
                    _c("li", [
                      _c("span", { staticClass: "bold600" }, [
                        _vm._v("Par téléphone ou autre")
                      ]),
                      _vm._v(
                        ' : Dans ce cas, vous devrez vous rendre dans la section "Commandes fournisseurs à envoyer" et sélectionner l\'icône du téléphone en fin de ligne pour indiquer que la commande a été passée.'
                      )
                    ]),
                    _c("li", [
                      _c("span", { staticClass: "bold600" }, [
                        _vm._v("Par mail depuis Mercudyn")
                      ]),
                      _vm._v(
                        " : Vous avez la possibilité d'envoyer un e-mail directement depuis Mercudyn. Pour ce faire, vous devrez d'abord renseigner votre profil avec votre adresse e-mail ainsi que celles des fournisseurs. Vous pouvez trouver ces étapes dans la section fournisseurs."
                      )
                    ])
                  ]),
                  _c("div", { staticClass: "flex-center-center mb-3" }, [
                    _c("div", { staticClass: "col-8" }, [
                      _c("img", {
                        staticClass: "border-black border-rounded w-100",
                        attrs: {
                          src: require("../../assets/images/documentation/commandes/suivi/bonDeCommande.png"),
                          alt: "Image bon de commande"
                        }
                      })
                    ])
                  ]),
                  _c("p", [
                    _vm._v(
                      "Si vous utilisez la fonction de messagerie, vous avez la possibilité d'imprimer et d'envoyer votre commande à tous les fournisseurs en une seule action. Cependant, si vous ne souhaitez pas imprimer, vous pouvez décocher la case \"IMPRESSION\"."
                    )
                  ]),
                  _c("div", { staticClass: "h6 important" }, [
                    _c("p", [
                      _vm._v(
                        " Vous recevrez une copie de chaque e-mail envoyé."
                      )
                    ]),
                    _c("p", [
                      _vm._v(
                        "En cas d'erreur de réception de l'e-mail par un fournisseur, vous serez averti par e-mail, et la commande sera marquée en rouge sur Mercudyn. Nous vous recommandons de contacter le fournisseur par téléphone pour vérifier son adresse e-mail et finaliser la commande."
                      )
                    ])
                  ])
                ])
              ]),
              _c("section", { attrs: { id: "sectionReception" } }, [
                _c("div", { staticClass: "header header-tertiary" }, [
                  _vm._v("Réception de commande")
                ]),
                _c("div", { staticClass: "card-body" }, [
                  _c("p", [
                    _vm._v(
                      'Après avoir cliqué sur le bouton "Réceptionner la commande", la page ci-dessous s\'affiche :'
                    )
                  ]),
                  _c("div", { staticClass: "card-body" }, [
                    _c("div", { staticClass: "container mb-3" }, [
                      _c("img", {
                        staticClass: "border-black border-rounded w-100",
                        attrs: {
                          src: require("../../assets/images/documentation/commandes/suivi/commandeReception.png"),
                          alt: "Image commandes Suivi"
                        }
                      })
                    ])
                  ]),
                  _c("p", [
                    _vm._v(
                      "Dans la barre du haut, de gauche à droite, vous trouverez les éléments suivants :"
                    )
                  ]),
                  _c("ul", { staticClass: "puces" }, [
                    _c("li", [
                      _vm._v(
                        "Ajouter un article: Si vous ajoutez un produit directement par téléphone après avoir validé la commande, vous avez la possibilité de l'ajouter lors de la réception de la commande."
                      )
                    ]),
                    _c("li", [
                      _vm._v(
                        "Déclarer un incident: Ce bouton sert a déclater un incident sur la totalité de la commande. Vous pouvez également déclarer un incident par ligne produit en utilisant le triangle avec le point d'exclamation."
                      )
                    ]),
                    _c("li", [
                      _vm._v(
                        "Ajouter un lot: Lors de la création d'un lot, il faut que la somme des quantités soit égale à la quantité livrée.Ensuite, vous avez la possibilité d'indiquer les numéros de lot et les dates limites de consommation (DLC)."
                      )
                    ]),
                    _c("li", [
                      _vm._v(
                        "Annuler: Annule le contrôle à réception, retourne vers la page de commande."
                      )
                    ]),
                    _c("li", [
                      _vm._v(
                        "Enregistrer en stock: Enregistre les produits en stock."
                      )
                    ])
                  ])
                ])
              ]),
              _c("section", { attrs: { id: "sectionSpeciaux" } }, [
                _c("div", { staticClass: "header header-tertiary" }, [
                  _vm._v("Spéciaux")
                ]),
                _c("div", { staticClass: "card-body" }, [
                  _c("div", { staticClass: "card-body" }, [
                    _c("div", { staticClass: "container mb-3" }, [
                      _c("img", {
                        staticClass: "border-black border-rounded w-100",
                        attrs: {
                          src: require("../../assets/images/documentation/commandes/speciaux/pageSpeciaux.png"),
                          alt: "Image liste produits Hors Marché"
                        }
                      })
                    ])
                  ]),
                  _c("p", [
                    _vm._v(
                      "Sur la page des spéciaux, vous trouverez tous les documents déposés par les fournisseurs et les industriels"
                    )
                  ]),
                  _c("p", [
                    _vm._v(
                      "Les fournisseurs ou industriels en vert sont ceux qui ont déposé de nouveaux documents."
                    )
                  ]),
                  _c("p", [
                    _vm._v(
                      "Vous avez la possibilité d'utiliser différents filtres :"
                    )
                  ]),
                  _c("ul", { staticClass: "puces" }, [
                    _c("li", [
                      _vm._v(
                        "1 . Le premier filtre vous sert à classer les documents par les fournisseurs qui proposent des documents alimentaires ou non alimentaires."
                      )
                    ]),
                    _c("li", [
                      _vm._v(
                        "2 . Le second vous propose de filtrer par famille."
                      )
                    ]),
                    _c("li", [
                      _vm._v(
                        "3 . Vous avez la possibilité d'effectuer une recherche de document dans la section 3."
                      )
                    ])
                  ])
                ])
              ]),
              _c("section", { attrs: { id: "sectionProduitsHM" } }, [
                _c("div", { staticClass: "header header-tertiary" }, [
                  _vm._v("Produits Hors Marché")
                ]),
                _c("div", { staticClass: "card-body" }, [
                  _c("p", [
                    _vm._v(
                      "Vous pouvez ajouter des produits provenant de vos fournisseurs locaux, ou des produits non référencés de la mercuriale sur les fournisseurs connus. La liste de vos produits est disponible sur cet écran : "
                    )
                  ]),
                  _c("div", { staticClass: "card-body" }, [
                    _c("div", { staticClass: "container mb-3" }, [
                      _c("img", {
                        staticClass: "border-black border-rounded w-100",
                        attrs: {
                          src: require("../../assets/images/documentation/commandes/produitsHM/listeProduitsHM.png"),
                          alt: "Image liste produits Hors Marché"
                        }
                      })
                    ])
                  ]),
                  _c("p", [
                    _vm._v(
                      "Dans la barre du haut, de gauche à droite, vous trouverez les éléments suivants :"
                    )
                  ]),
                  _c("ul", { staticClass: "puces" }, [
                    _c("li", [
                      _c(
                        "a",
                        { attrs: { href: "#sectionCreationProduitsHM" } },
                        [_vm._v("Ajouter un produit:")]
                      ),
                      _vm._v(
                        " Permet de créer un produit hors marché, avec le tarif d'un fournisseur"
                      )
                    ]),
                    _c("li", [
                      _vm._v(
                        "Dupliquer le produit: Permet de dupliquer un produit hors marché, afin de créer un nouveau tarif fournisseur par exemple"
                      )
                    ]),
                    _c("li", [
                      _c(
                        "a",
                        { attrs: { href: "#sectionCreationProduitsHM" } },
                        [_vm._v("Modifier:")]
                      ),
                      _vm._v(" Modification du produit sélectionné.")
                    ]),
                    _c("li", [
                      _vm._v("Supprimer: Suppression du produit sélectionné.")
                    ]),
                    _c("li", [
                      _vm._v(
                        "Enregistrer: Ce bouton apparait si vous avez des produits sans ingrédient rattaché."
                      )
                    ])
                  ]),
                  _c("p", [
                    _vm._v(
                      "A partir de cette liste, si certains produits n'ont pas d'ingrédient associé, l'indication "
                    ),
                    _c("em", { staticClass: "warning" }, [
                      _c("i", {
                        staticClass:
                          "fas fa-exclamation-triangle ligne-modifiee warning"
                      }),
                      _vm._v(" Produit sans ingrédient")
                    ]),
                    _vm._v(
                      ' est visible dans la désignation. Vous pouvez les modifier directement, en cherchant l\'ingrédient depuis la zone de recherche, et enregistrer les produits modifiés via le bouton "Enregistrer"'
                    )
                  ]),
                  _c("p", [
                    _vm._v(
                      "Cette liste peut etre triée lorsque l'on clique sur l'entête du tableau."
                    )
                  ]),
                  _c("p", [
                    _vm._v(
                      "Cette liste peut etre filtrée sur une ou plusieurs familles, à partir d'une recherche libre, ou uniquement les produits en erreur. Les produits en erreur correspondent aux articles qui n'ont pas d'ingrédient ou aucun allergène de renseigné."
                    )
                  ])
                ])
              ]),
              _c("section", { attrs: { id: "sectionCreationProduitsHM" } }, [
                _c("div", { staticClass: "header header-tertiary" }, [
                  _vm._v("Création/Modification d'un produit hors marché")
                ]),
                _c("div", { staticClass: "card-body" }, [
                  _c("p", [
                    _vm._v(
                      "La création, modification ou duplication d'un produit hors marché se fait à partir de la fenêtre ci-dessous: "
                    )
                  ]),
                  _c("div", { staticClass: "card-body" }, [
                    _c(
                      "div",
                      { staticClass: "container flex-center-center mb-3" },
                      [
                        _c("img", {
                          staticClass: "border-black border-rounded w-50",
                          attrs: {
                            src: require("../../assets/images/documentation/commandes/produitsHM/creationProduitsHM.png"),
                            alt:
                              "Image création ou modification d'un produit hors marché"
                          }
                        })
                      ]
                    )
                  ]),
                  _c("p", [
                    _vm._v("Points importants sur la création d'un produit :")
                  ]),
                  _c("ul", { staticClass: "puces" }, [
                    _c("li", [
                      _vm._v(
                        "L'ingrédient est facultatif, cependant nous vous conseillons de le renseigner afin que Mercudyn puisse proposer les bonnes substitutions d'articles sur vos commandes."
                      )
                    ]),
                    _c("li", [
                      _vm._v(
                        "La désignation correspond à celle du fournisseur sélectionné."
                      )
                    ]),
                    _c("li", [
                      _vm._v(
                        'Si votre produit ne contient aucun allergène, vous devez sélectionner "Aucun Allergène" dans la liste déroulante.'
                      )
                    ]),
                    _c("li", [
                      _vm._v(
                        "Le PCB correspond à par combien le produit est vendu et par quelle unité."
                      )
                    ]),
                    _c("li", [
                      _vm._v(
                        "Le prix unitaire correspond à l'unité de vente. Exemple : Si vous mettez un PCB \"15 cartons\", le prix unitaire correspond au prix d'un carton. Le montant HT est calculé automatiquement en suivant cette règle."
                      )
                    ]),
                    _c("li", [
                      _vm._v(
                        "Le paramétrage facultatif permet de définir la répartition du produit sur différentes unités. Celui-ci est necessaire pour le bon calcul de commandes depuis vos menus et recette ainsi que vos mises en production."
                      )
                    ]),
                    _c("li", [
                      _vm._v(
                        'Exemple : le produit est vendu par 2,5 Kg. La répartition pourra être définie comme ceci : "Dans 2,5 Kg je vais avoir 1 Pièce, 2,5 Kg, 0 Litre" '
                      )
                    ]),
                    _c("li", [
                      _vm._v(
                        "Deux phrases explicatives vous permettent de voir le résultat de votre répartition."
                      )
                    ])
                  ]),
                  _c("p", [
                    _vm._v(
                      "Lorsque le produit est enregistré, il est visible depuis la page "
                    ),
                    _c("a", { attrs: { href: "#sectionMercuriale" } }, [
                      _vm._v('"Mercuriale"')
                    ]),
                    _vm._v(" et commandable directement depuis vos commandes.")
                  ])
                ])
              ])
            ]
          )
        ]
      )
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }